import createCachedSelector from 're-reselect';
import { RootState } from 'src/store';

const getSku = (state: RootState, skuId: string) => state.skus[skuId];

const getSkuById = createCachedSelector([getSku], (skuData) => skuData)((state, skuId) => skuId);

export default getSkuById;
